import { useQuery } from "@tanstack/react-query";

import { getFootprintingCropPlantProtection, getFootprintingCropPlantProtectionAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_FARM_CROP_PLANT_PROTECTION } from "consts";

export const useGetFootprintingCropPlantProtection = (primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;
  const queryFn = isAdmin ? getFootprintingCropPlantProtectionAdmin : getFootprintingCropPlantProtection;

  return useQuery({
    queryKey: [FOOTPRINTING_FARM_CROP_PLANT_PROTECTION, primaryDataId],
    queryFn: () => queryFn(primaryDataId ?? ""),
    enabled: !!primaryDataId,
    gcTime: 0,
  });
};
